<template>
  <el-dialog :title="editFormTitle" :visible.sync="visible" width="600px" center>
    <el-form :model="editForm">
      <el-form-item label="指定账户" :label-width="formLabelWidth">
        <el-input v-model="editForm.tel" autocomplete="off" placeholder="请输入领取人手机号"></el-input>
      </el-form-item>
      <el-form-item label="  " :label-width="formLabelWidth">
        <div style="font-size: 12px; color: red; line-height: 1.5;">优惠券发放后不可撤销，请仔细核对用户信息是否正确！ 多人用英文逗号隔开</div>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleSubmit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { isEmpty } from '@/utils'
import { sendCoupon } from '../../../api'

export default {
  name: 'SendDiscount',
  data() {
    return {
      id: null,
      editForm: {
        tel: ''
      },
      formLabelWidth: '153px',
      visible: false
    }
  },
  computed: {
    editFormTitle() {
      return '发放优惠券'
    }
  },
  methods: {
    async handleOpen(val) {
      const defaultFrom = {
        tel: ''
      }
      this.id = val
      this.editForm = defaultFrom
      this.visible = true
    },
    handleSubmit() {
      const { id: coupon_batch } = this
      const {
        tel } = this.editForm
      if (isEmpty(tel)) return this.$message({ message: '请输入手机号！', type: 'warning' })

      const params = {
        coupon_batch,
        tel,
        username: sessionStorage.getItem('username')
      }
      sendCoupon(params).then(res => {
        if (res.status) {
          this.$message.success(res.msg)
          this.handleClose()
          this.$emit('update')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleClose() {
      this.visible = false
    }
  }
}
</script>

<style scoped>

</style>
